module.exports = __webpack_public_path__ + "assets-cabinet/img/crumb-icon.1c2bbd9b.svg";